import PropTypes from "prop-types";
import React from "react";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { FixedWidth } from "../../../../CommonComponents/commonStyles";
import LegacyOptions from "./Components/LegacyOptions/LegacyOptions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  grantOptionPdf,
  fetchSuccessionValues,
  fetchDropdownValues
} from "../../actions";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";

class Step2Main extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.fetchSuccessionValues({
      metaData: {
        method: "GET",
        page: "editSuccession",
        url: `/donor-portal/api/profile/${getPrimaryAccount().userId}/getSuccessionPlans`
      }
    });
    this.props.fetchDropdownValues({
      metaData: [
        {
          method: "GET",
          page: "editSuccession",
          url: `/donor-portal/api/dropDownValues/getCodeValueMapping`
        },
        {
          method: "GET",
          page: "editSuccession",
          url: `/DP/Relationship/Types`,
          isBhoomiUrl:true
        }
      ]
    });
  }

  render() {
    if (this.props.isLoading) return <Preloader data-test="contentLoader"/>;
    return (
      <FixedWidth data-test="contentMain">
        <LegacyOptions legacyOptions={this.props.legacyOptions} />
      </FixedWidth>
    );
  }
}


Step2Main.propTypes = {
  fetchDropdownValues: PropTypes.func,
  fetchSuccessionValues: PropTypes.func,
  isLoading: PropTypes.any,
  legacyOptions: PropTypes.arrayOf(PropTypes.shape({
    accountId: PropTypes.number,
    assignedPercentage: PropTypes.number,
    note: PropTypes.any,
    optionId: PropTypes.number,
    optionName: PropTypes.string,
    otherSuccessionDetailsList: PropTypes.any,
    planType: PropTypes.any,
    selected: PropTypes.bool,
    successionPlanGranteeOrg: PropTypes.any,
    successionPlanId: PropTypes.number,
    successorAdvisor: PropTypes.arrayOf(PropTypes.shape({
      address: PropTypes.shape({
        addrType: PropTypes.shape({
          codeId: PropTypes.number,
          codeType: PropTypes.any,
          codeValue: PropTypes.any,
          contributionSourceOther: PropTypes.any,
          declinedFurtherRevReason: PropTypes.any,
          description: PropTypes.any,
          displayOrder: PropTypes.any,
          extDescription: PropTypes.any,
          extraStatusOne: PropTypes.any,
          partyId: PropTypes.number,
          vgReferrerDeptOther: PropTypes.any
        }),
        addressId: PropTypes.number,
        city: PropTypes.string,
        country: PropTypes.string,
        descriptor: PropTypes.any,
        foreignFlag: PropTypes.string,
        foreignState: PropTypes.any,
        fromDate: PropTypes.any,
        line1: PropTypes.string,
        line2: PropTypes.any,
        line3: PropTypes.any,
        line4: PropTypes.any,
        loggedInDonorAddress: PropTypes.any,
        primaryFlag: PropTypes.any,
        state: PropTypes.any,
        stateType: PropTypes.any,
        toDate: PropTypes.any,
        zip: PropTypes.string,
        zipExt: PropTypes.any
      }),
      dob: PropTypes.number,
      dobStr: PropTypes.any,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      middleName: PropTypes.any,
      notes: PropTypes.any,
      preferedEmail: PropTypes.any,
      preferedPhone: PropTypes.any,
      relationshipType: PropTypes.string,
      successionDetailId: PropTypes.number,
      successionPlanId: PropTypes.number,
      suffix: PropTypes.any,
      title: PropTypes.any
    }))
  }))
};

const mapStateToProps = state => ({
  legacyOptions: state.getIn(["myAccount", "successionPlan", "data"]),
  isLoading: state.getIn(["myAccount", "successionPlan", "isLoading"])
});

export const mapDispatchToProps = dispatch => ({
  fetchSuccessionValues: data => dispatch(fetchSuccessionValues(data)),
  fetchDropdownValues: data => dispatch(fetchDropdownValues(data)),
  grantOptionPdf: data => dispatch(grantOptionPdf(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Step2Main)
);
